import MobileExploreMapSwitch from './MobileExploreMapSwitch';

export default MobileExploreMapSwitch;
